import React from 'react';
import { useNavigation } from '../NavigationContext';

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,700;0,800;0,900;1,700&family=Inter:wght@300;400;500;600;700;800&display=swap');

  .dr-page * { box-sizing: border-box; margin: 0; padding: 0; }
  .dr-page { font-family: 'Inter', sans-serif; color: #0d1b3e; background: #ffffff; width: 100%; }

  /* ── Hero ── */
  .dr-hero { position: relative; padding: 100px 24px 120px; overflow: hidden; background: #fff; }
  .dr-hero-blob1 { position: absolute; top: -10%; right: -5%; width: 600px; height: 600px; border-radius: 50%; background: radial-gradient(circle, rgba(220,38,38,0.06), rgba(13,27,62,0.04)); filter: blur(90px); pointer-events: none; }
  .dr-hero-blob2 { position: absolute; bottom: -15%; left: -10%; width: 700px; height: 700px; border-radius: 50%; background: radial-gradient(circle, rgba(30,58,138,0.07), rgba(220,38,38,0.04)); filter: blur(90px); pointer-events: none; }
  .dr-hero-inner { max-width: 1200px; margin: 0 auto; display: grid; grid-template-columns: 1fr 1fr; gap: 64px; align-items: center; position: relative; z-index: 1; }
  @media (max-width: 900px) { .dr-hero-inner { grid-template-columns: 1fr; } .dr-hero-card { display: none; } }

  .dr-badge { display: inline-flex; align-items: center; gap: 8px; padding: 8px 16px; border-radius: 999px; background: #fff1f2; border: 1px solid #fecdd3; font-size: 13px; font-weight: 500; color: #9f1239; margin-bottom: 28px; }
  .dr-badge-dot { width: 8px; height: 8px; border-radius: 50%; background: #dc2626; display: inline-block; animation: dr-pulse 2s ease-in-out infinite; }
  @keyframes dr-pulse { 0%, 100% { box-shadow: 0 0 0 0 rgba(220,38,38,0.5); } 50% { box-shadow: 0 0 0 6px rgba(220,38,38,0); } }

  .dr-hero h1 { font-family: 'Playfair Display', Georgia, serif; font-size: clamp(1.8rem, 3.375vw, 2.85rem); font-weight: 800; line-height: 1.1; letter-spacing: -0.02em; color: #0d1b3e; margin-bottom: 24px; }
  .dr-gradient-text { background: linear-gradient(135deg, #dc2626 0%, #0d1b3e 100%); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text; }
  .dr-hero-sub { font-size: 1.1rem; color: #475569; line-height: 1.8; margin-bottom: 40px; }
  .dr-btn-group { display: flex; gap: 16px; flex-wrap: wrap; margin-bottom: 44px; }
  .dr-btn-primary { padding: 14px 28px; background: #0d1b3e; color: #fff; border: none; border-radius: 10px; font-size: 15px; font-weight: 600; cursor: pointer; display: inline-flex; align-items: center; gap: 8px; transition: all 0.2s; }
  .dr-btn-primary:hover { background: #dc2626; transform: translateY(-2px); box-shadow: 0 8px 24px rgba(220,38,38,0.3); }
  .dr-back-btn { display: flex; width: fit-content; align-items: center; gap: 8px; font-size: 14px; font-weight: 600; color: #dc2626; background: none; border: none; cursor: pointer; padding: 0; margin-bottom: 24px; transition: color 0.2s; }
  .dr-back-btn:hover { color: #b91c1c; }
  .dr-btn-secondary { padding: 14px 28px; background: #fff; color: #0d1b3e; border: 1.5px solid #cbd5e1; border-radius: 10px; font-size: 15px; font-weight: 600; cursor: pointer; transition: all 0.2s; }
  .dr-btn-secondary:hover { border-color: #dc2626; color: #9f1239; background: #fff1f2; }
  .dr-trust-items { display: flex; gap: 24px; flex-wrap: wrap; }
  .dr-trust-item { display: flex; align-items: center; gap: 8px; font-size: 13px; color: #64748b; font-weight: 500; }
  .dr-trust-check { width: 20px; height: 20px; background: #fee2e2; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 10px; color: #dc2626; flex-shrink: 0; }

  /* Hero Card */
  .dr-hero-card { background: #fff; border-radius: 24px; border: 1px solid #e2e8f0; padding: 32px; box-shadow: 0 24px 64px rgba(13,27,62,0.09), 0 4px 16px rgba(0,0,0,0.04); }
  .dr-card-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; padding-bottom: 16px; border-bottom: 1px solid #f1f5f9; }
  .dr-card-title-label { font-size: 12px; color: #94a3b8; font-weight: 500; margin-bottom: 3px; }
  .dr-card-title-value { font-size: 15px; font-weight: 700; color: #0d1b3e; }
  .dr-card-live { background: #fee2e2; color: #991b1b; font-size: 11px; font-weight: 600; padding: 4px 10px; border-radius: 999px; }
  .dr-timeline { display: flex; flex-direction: column; gap: 0; margin-bottom: 14px; }
  .dr-timeline-item { display: flex; gap: 14px; position: relative; }
  .dr-timeline-item:not(:last-child) .dr-tl-line { height: 100%; }
  .dr-tl-left { display: flex; flex-direction: column; align-items: center; width: 28px; flex-shrink: 0; }
  .dr-tl-dot { width: 28px; height: 28px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 12px; font-weight: 700; flex-shrink: 0; z-index: 1; }
  .dr-tl-dot.done { background: #dcfce7; color: #166534; }
  .dr-tl-dot.active { background: #fef9c3; color: #854d0e; }
  .dr-tl-dot.pending { background: #f1f5f9; color: #94a3b8; }
  .dr-tl-line { width: 2px; flex: 1; background: #f1f5f9; margin: 4px 0; min-height: 20px; }
  .dr-tl-content { padding-bottom: 16px; padding-top: 4px; }
  .dr-tl-title { font-size: 12.5px; font-weight: 700; color: #334155; }
  .dr-tl-sub { font-size: 11px; color: #94a3b8; margin-top: 1px; }
  .dr-card-metric { padding: 16px 18px; background: linear-gradient(135deg, #7f1d1d, #dc2626); border-radius: 12px; display: flex; justify-content: space-between; align-items: center; }
  .dr-metric-label { font-size: 11px; color: rgba(255,255,255,0.75); margin-bottom: 3px; }
  .dr-metric-value { font-size: 22px; font-weight: 800; color: #fff; }
  .dr-metric-badge { background: rgba(255,255,255,0.2); border: 1px solid rgba(255,255,255,0.3); border-radius: 999px; padding: 4px 12px; font-size: 11px; font-weight: 600; color: #fff; }

  /* ── Stats ── */
  .dr-stats { border-top: 1px solid #f1f5f9; border-bottom: 1px solid #f1f5f9; }
  .dr-stats-grid { display: grid; grid-template-columns: repeat(4, 1fr); max-width: 1200px; margin: 0 auto; }
  @media (max-width: 768px) { .dr-stats-grid { grid-template-columns: 1fr 1fr; } }
  .dr-stat-item { padding: 36px 24px; text-align: center; border-right: 1px solid #f1f5f9; }
  .dr-stat-item:last-child { border-right: none; }
  @media (max-width: 768px) { .dr-stat-item:nth-child(2n) { border-right: none; } .dr-stat-item { border-bottom: 1px solid #f1f5f9; } }
  .dr-stat-num { font-family: 'Playfair Display', serif; font-size: 2.2rem; font-weight: 800; color: #dc2626; letter-spacing: -0.03em; line-height: 1; margin-bottom: 8px; }
  .dr-stat-label { font-size: 0.82rem; color: #64748b; font-weight: 500; }

  /* ── Shared ── */
  .dr-section { padding: 96px 24px; }
  .dr-container { max-width: 1200px; margin: 0 auto; }
  .dr-section-header { text-align: center; max-width: 720px; margin: 0 auto 64px; }
  .dr-section-header h2 { font-family: 'Playfair Display', serif; font-size: clamp(1.8rem, 3.5vw, 2.8rem); font-weight: 800; color: #0d1b3e; letter-spacing: -0.02em; margin-bottom: 16px; line-height: 1.2; }
  .dr-section-header p { font-size: 1.05rem; color: #64748b; line-height: 1.78; }
  .dr-kicker { font-size: 12px; font-weight: 700; letter-spacing: 0.1em; text-transform: uppercase; color: #dc2626; margin-bottom: 12px; }

  /* ── Methods ── */
  .dr-methods-bg { background: #f8fafc; border-top: 1px solid rgba(226,232,240,0.6); border-bottom: 1px solid rgba(226,232,240,0.6); }
  .dr-methods-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 28px; }
  @media (max-width: 768px) { .dr-methods-grid { grid-template-columns: 1fr; } }
  .dr-method-card { background: #fff; border-radius: 22px; overflow: hidden; border: 1px solid rgba(226,232,240,0.7); box-shadow: 0 1px 4px rgba(0,0,0,0.03); transition: all 0.3s; }
  .dr-method-card:hover { box-shadow: 0 16px 48px rgba(0,0,0,0.08); transform: translateY(-3px); }
  .dr-method-header { padding: 28px 28px 20px; }
  .dr-method-icon { font-size: 32px; margin-bottom: 14px; }
  .dr-method-title { font-size: 1.1rem; font-weight: 800; color: #0d1b3e; margin-bottom: 6px; }
  .dr-method-subtitle { font-size: 12px; font-weight: 600; color: #dc2626; text-transform: uppercase; letter-spacing: 0.06em; margin-bottom: 12px; }
  .dr-method-desc { font-size: 0.88rem; color: #64748b; line-height: 1.72; }
  .dr-method-footer { padding: 16px 28px 24px; border-top: 1px solid #f1f5f9; }
  .dr-method-stats { display: flex; gap: 20px; }
  .dr-method-stat { }
  .dr-method-stat-num { font-size: 1.3rem; font-weight: 800; color: #0d1b3e; letter-spacing: -0.02em; }
  .dr-method-stat-label { font-size: 10.5px; color: #94a3b8; font-weight: 500; }
  .dr-method-pros { padding: 0 28px 24px; display: flex; flex-direction: column; gap: 8px; }
  .dr-method-pro { display: flex; align-items: center; gap: 10px; font-size: 12.5px; color: #334155; font-weight: 500; }
  .dr-method-pro::before { content: '✓'; color: #22c55e; font-size: 12px; font-weight: 700; flex-shrink: 0; }

  /* ── Cost Comparison ── */
  .dr-cost-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 72px; align-items: start; }
  @media (max-width: 900px) { .dr-cost-grid { grid-template-columns: 1fr; gap: 48px; } }
  .dr-cost-left h2 { font-family: 'Playfair Display', serif; font-size: clamp(1.8rem, 3vw, 2.5rem); font-weight: 800; color: #0d1b3e; letter-spacing: -0.02em; line-height: 1.2; margin-bottom: 18px; }
  .dr-cost-left p { font-size: 1rem; color: #64748b; line-height: 1.78; margin-bottom: 32px; }
  .dr-cost-bars { display: flex; flex-direction: column; gap: 20px; }
  .dr-cost-bar-item { }
  .dr-cost-bar-top { display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px; }
  .dr-cost-bar-label { font-size: 13px; font-weight: 700; color: #0d1b3e; }
  .dr-cost-bar-amount { font-size: 13px; font-weight: 700; color: #64748b; }
  .dr-cost-bar-track { height: 10px; background: #f1f5f9; border-radius: 999px; overflow: hidden; }
  .dr-cost-bar-fill { height: 100%; border-radius: 999px; }
  .dr-benefit-list-items { display: flex; flex-direction: column; gap: 20px; }
  .dr-ben-item { display: flex; gap: 16px; }
  .dr-ben-icon { width: 42px; height: 42px; border-radius: 12px; background: #fff1f2; display: flex; align-items: center; justify-content: center; font-size: 18px; flex-shrink: 0; margin-top: 2px; }
  .dr-ben-title { font-size: 0.95rem; font-weight: 700; color: #0d1b3e; margin-bottom: 5px; }
  .dr-ben-desc { font-size: 0.88rem; color: #64748b; line-height: 1.65; }

  /* ── Process ── */
  .dr-process-bg { background: #f8fafc; border-top: 1px solid rgba(226,232,240,0.6); border-bottom: 1px solid rgba(226,232,240,0.6); }
  .dr-process-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 32px; position: relative; }
  @media (max-width: 900px) { .dr-process-grid { grid-template-columns: 1fr 1fr; } }
  @media (max-width: 600px) { .dr-process-grid { grid-template-columns: 1fr; } }
  .dr-process-grid::before { content: ''; position: absolute; top: 27px; left: 12.5%; right: 12.5%; height: 2px; background: linear-gradient(90deg, #dc2626, #f87171); z-index: 0; }
  @media (max-width: 900px) { .dr-process-grid::before { display: none; } }
  .dr-process-step { text-align: center; position: relative; z-index: 1; }
  .dr-process-num { width: 56px; height: 56px; border-radius: 50%; background: #0d1b3e; color: #fff; font-size: 1rem; font-weight: 800; display: flex; align-items: center; justify-content: center; margin: 0 auto 20px; border: 4px solid #f8fafc; box-shadow: 0 0 0 2px #0d1b3e; }
  .dr-process-title { font-size: 0.95rem; font-weight: 700; color: #0d1b3e; margin-bottom: 8px; }
  .dr-process-desc { font-size: 0.85rem; color: #64748b; line-height: 1.65; }

  /* ── CTA ── */
  .dr-cta { background: linear-gradient(135deg, #0d1b3e 0%, #7f1d1d 60%, #0d1b3e 100%); padding: 96px 24px; position: relative; overflow: hidden; }
  .dr-cta-blob1 { position: absolute; top: -80px; right: -60px; width: 380px; height: 380px; border-radius: 50%; background: rgba(248,113,113,0.07); filter: blur(60px); pointer-events: none; }
  .dr-cta-blob2 { position: absolute; bottom: -60px; left: -40px; width: 320px; height: 320px; border-radius: 50%; background: rgba(255,255,255,0.04); filter: blur(60px); pointer-events: none; }
  .dr-cta-inner { max-width: 720px; margin: 0 auto; text-align: center; position: relative; z-index: 1; }
  .dr-cta-tag { display: inline-block; background: rgba(248,113,113,0.16); border: 1px solid rgba(248,113,113,0.35); border-radius: 999px; padding: 6px 16px; font-size: 12px; font-weight: 700; color: #fca5a5; letter-spacing: 0.08em; text-transform: uppercase; margin-bottom: 24px; }
  .dr-cta h2 { font-family: 'Playfair Display', serif; font-size: clamp(2rem, 4vw, 3rem); font-weight: 800; color: #fff; margin-bottom: 20px; line-height: 1.2; letter-spacing: -0.02em; }
  .dr-cta p { font-size: 1.1rem; color: rgba(255,255,255,0.78); line-height: 1.75; margin-bottom: 44px; }
  .dr-cta-btn-group { display: flex; gap: 16px; justify-content: center; flex-wrap: wrap; margin-bottom: 36px; }
  .dr-cta-btn-primary { padding: 16px 32px; background: #dc2626; color: #fff; border: none; border-radius: 10px; font-size: 16px; font-weight: 700; cursor: pointer; transition: all 0.2s; }
  .dr-cta-btn-primary:hover { background: #b91c1c; transform: translateY(-2px); box-shadow: 0 8px 24px rgba(220,38,38,0.4); }
  .dr-cta-btn-secondary { padding: 16px 32px; background: transparent; color: #fff; border: 1.5px solid rgba(255,255,255,0.35); border-radius: 10px; font-size: 16px; font-weight: 600; cursor: pointer; transition: all 0.2s; }
  .dr-cta-btn-secondary:hover { border-color: rgba(255,255,255,0.65); background: rgba(255,255,255,0.07); }
  .dr-cta-reassurances { display: flex; gap: 24px; justify-content: center; flex-wrap: wrap; }
  .dr-cta-reassurance { display: flex; align-items: center; gap: 8px; font-size: 13px; color: rgba(255,255,255,0.7); font-weight: 500; }
  .dr-cta-check { width: 18px; height: 18px; background: rgba(248,113,113,0.2); border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 9px; color: #fca5a5; flex-shrink: 0; }
`;

const timelineItems = [
  { dot: "done", title: "Initial Consultation", sub: "Case assessed & strategy set", status: "✓" },
  { dot: "done", title: "Demand Letter Sent", sub: "Opposing party notified", status: "✓" },
  { dot: "active", title: "Mediation Session", sub: "In progress — Day 2", status: "→" },
  { dot: "pending", title: "Resolution & Settlement", sub: "Pending agreement", status: "○" },
];

const methods = [
  {
    icon: "🤝",
    title: "Mediation",
    subtitle: "Fastest & Most Cost-Effective",
    desc: "A neutral third-party mediator facilitates negotiation between the parties. Confidential, non-binding, and typically resolved in days — not months.",
    stats: [{ num: "3–7", label: "Days avg." }, { num: "70%", label: "Success rate" }],
    pros: ["No court involvement", "Fully confidential", "Both parties retain control", "Lowest cost option"],
  },
  {
    icon: "⚖️",
    title: "Arbitration",
    subtitle: "Binding & Definitive",
    desc: "A private arbitrator hears both sides and issues a legally binding decision. Faster and less expensive than litigation with a predictable outcome.",
    stats: [{ num: "30–90", label: "Days avg." }, { num: "95%", label: "Enforceability" }],
    pros: ["Legally binding decision", "Private & discreet", "Faster than court", "Streamlined discovery"],
  },
  {
    icon: "🏛️",
    title: "Litigation Support",
    subtitle: "Court Representation",
    desc: "When mediation and arbitration aren't options, we provide experienced courtroom representation and litigation strategy to protect your interests.",
    stats: [{ num: "6–18", label: "Months avg." }, { num: "85%", label: "Cases won/settled" }],
    pros: ["Full legal representation", "Discovery & evidence management", "Trial-ready team", "Appeal support"],
  },
];

const costBars = [
  { label: "Mediation", amount: "$1,500 – $5,000", width: "20%", color: "#22c55e" },
  { label: "Arbitration", amount: "$5,000 – $25,000", width: "45%", color: "#f59e0b" },
  { label: "Traditional Litigation", amount: "$50,000 – $300,000+", width: "100%", color: "#dc2626" },
];

const benefits = [
  { icon: "💰", title: "Drastically Lower Costs", desc: "Mediation and arbitration typically cost 60–90% less than going to court — preserving your cash flow and business operations." },
  { icon: "🕐", title: "Faster Resolutions", desc: "Court cases drag on for years. Most disputes we handle resolve in weeks to months, letting you move forward faster." },
  { icon: "🔒", title: "Confidential Proceedings", desc: "Unlike public court records, alternative dispute resolution keeps your business matters private and out of the public eye." },
  { icon: "🤝", title: "Preserved Relationships", desc: "Mediation in particular allows both sides to reach mutually agreeable solutions — sometimes preserving valuable business relationships." },
];

const processSteps = [
  { num: "01", title: "Case Evaluation", desc: "We assess the dispute, identify the best resolution path, and outline your legal position and options." },
  { num: "02", title: "Strategy & Demand", desc: "We draft a formal demand letter and open negotiations, often resolving disputes before formal proceedings begin." },
  { num: "03", title: "Mediation or Arbitration", desc: "We represent your interests in mediation or arbitration sessions, advocating for the best possible outcome." },
  { num: "04", title: "Resolution & Enforcement", desc: "We document the final agreement and, where necessary, pursue court enforcement of binding decisions." },
];

const LegalDisputeResolution = () => {
  const { navigateTo } = useNavigation();

  return (
    <div className="dr-page">
      <style>{styles}</style>

      {/* ── Hero ── */}
      <section className="dr-hero">
        <div className="dr-hero-blob1" />
        <div className="dr-hero-blob2" />
        <div className="dr-hero-inner">
          <div>
            <button className="dr-back-btn" onClick={() => navigateTo("")}>← Back to Legal Services</button>
            <div className="dr-badge">
              <span className="dr-badge-dot" />
              Dispute Resolution Services
            </div>
            <h1>
              Resolve Disputes.{" "}
              <span className="dr-gradient-text">Protect Your Business.</span>
            </h1>
            <p className="dr-hero-sub">
              Business disputes are inevitable. Costly litigation isn't. We
              specialize in mediation, arbitration, and litigation support — giving
              you the fastest, most cost-effective path to resolution so you can
              get back to business.
            </p>
            <div className="dr-btn-group">
              <button className="dr-btn-primary">Get a Case Evaluation →</button>
              <button className="dr-btn-secondary">Compare Options</button>
            </div>
            <div className="dr-trust-items">
              {["Mediation · Arbitration · Litigation", "60–90% lower than court", "Confidential proceedings", "Preserve business relationships"].map((t, i) => (
                <div key={i} className="dr-trust-item">
                  <span className="dr-trust-check">✓</span>
                  {t}
                </div>
              ))}
            </div>
          </div>

          <div className="dr-hero-card">
            <div className="dr-card-header">
              <div>
                <div className="dr-card-title-label">Active Dispute</div>
                <div className="dr-card-title-value">Resolution Timeline</div>
              </div>
              <span className="dr-card-live">● In Progress</span>
            </div>
            <div className="dr-timeline">
              {timelineItems.map((item, i) => (
                <div key={i} className="dr-timeline-item">
                  <div className="dr-tl-left">
                    <div className={`dr-tl-dot ${item.dot}`}>{item.status}</div>
                    {i < timelineItems.length - 1 && <div className="dr-tl-line" />}
                  </div>
                  <div className="dr-tl-content">
                    <div className="dr-tl-title">{item.title}</div>
                    <div className="dr-tl-sub">{item.sub}</div>
                  </div>
                </div>
              ))}
            </div>
            <div className="dr-card-metric">
              <div>
                <div className="dr-metric-label">Estimated Savings vs. Litigation</div>
                <div className="dr-metric-value">$42,000</div>
              </div>
              <div className="dr-metric-badge">Via Mediation</div>
            </div>
          </div>
        </div>
      </section>

      {/* ── Stats ── */}
      <section className="dr-stats">
        <div className="dr-stats-grid">
          {[
            { num: "900+", label: "Disputes Resolved" },
            { num: "85%", label: "Avoid Litigation" },
            { num: "$12M+", label: "In Settlements Secured" },
            { num: "4× ", label: "Faster Than Court Avg." },
          ].map((s, i) => (
            <div key={i} className="dr-stat-item">
              <div className="dr-stat-num">{s.num}</div>
              <div className="dr-stat-label">{s.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* ── Methods ── */}
      <section className="dr-section dr-methods-bg">
        <div className="dr-container">
          <div className="dr-section-header">
            <div className="dr-kicker">Resolution Options</div>
            <h2>Find the Right Path for Your Dispute</h2>
            <p>
              Not every dispute requires a courtroom. We help you choose and
              execute the resolution method that gets you the best outcome at the
              lowest cost and in the least amount of time.
            </p>
          </div>
          <div className="dr-methods-grid">
            {methods.map((method, i) => (
              <div key={i} className="dr-method-card">
                <div className="dr-method-header">
                  <div className="dr-method-icon">{method.icon}</div>
                  <div className="dr-method-title">{method.title}</div>
                  <div className="dr-method-subtitle">{method.subtitle}</div>
                  <div className="dr-method-desc">{method.desc}</div>
                </div>
                <div className="dr-method-footer">
                  <div className="dr-method-stats">
                    {method.stats.map((stat, j) => (
                      <div key={j} className="dr-method-stat">
                        <div className="dr-method-stat-num">{stat.num}</div>
                        <div className="dr-method-stat-label">{stat.label}</div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="dr-method-pros">
                  {method.pros.map((pro, j) => (
                    <div key={j} className="dr-method-pro">{pro}</div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Cost Comparison ── */}
      <section className="dr-section">
        <div className="dr-container">
          <div className="dr-cost-grid">
            <div className="dr-cost-left">
              <div className="dr-kicker">Cost Comparison</div>
              <h2>Why Going to Court Should Be Your Last Resort</h2>
              <p>
                Litigation is the most expensive, time-consuming, and emotionally
                draining way to resolve a business dispute. See how our alternative
                methods compare.
              </p>
              <div className="dr-cost-bars">
                {costBars.map((bar, i) => (
                  <div key={i} className="dr-cost-bar-item">
                    <div className="dr-cost-bar-top">
                      <span className="dr-cost-bar-label">{bar.label}</span>
                      <span className="dr-cost-bar-amount">{bar.amount}</span>
                    </div>
                    <div className="dr-cost-bar-track">
                      <div className="dr-cost-bar-fill" style={{ width: bar.width, background: bar.color }} />
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div>
              <div className="dr-kicker">Why Choose ADR</div>
              <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: 'clamp(1.6rem, 2.5vw, 2.2rem)', fontWeight: 800, color: '#0d1b3e', letterSpacing: '-0.02em', lineHeight: 1.2, marginBottom: '36px' }}>
                The Alternative Dispute Resolution Advantage
              </h2>
              <div className="dr-benefit-list-items">
                {benefits.map((b, i) => (
                  <div key={i} className="dr-ben-item">
                    <div className="dr-ben-icon">{b.icon}</div>
                    <div>
                      <div className="dr-ben-title">{b.title}</div>
                      <div className="dr-ben-desc">{b.desc}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── Process ── */}
      <section className="dr-section dr-process-bg">
        <div className="dr-container">
          <div className="dr-section-header">
            <div className="dr-kicker">Our Process</div>
            <h2>From First Call to Final Resolution</h2>
            <p>We move fast, communicate clearly, and keep your interests front and center at every stage.</p>
          </div>
          <div className="dr-process-grid">
            {processSteps.map((step, i) => (
              <div key={i} className="dr-process-step">
                <div className="dr-process-num">{step.num}</div>
                <div className="dr-process-title">{step.title}</div>
                <div className="dr-process-desc">{step.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section className="dr-cta">
        <div className="dr-cta-blob1" />
        <div className="dr-cta-blob2" />
        <div className="dr-cta-inner">
          <div className="dr-cta-tag">Free Case Evaluation</div>
          <h2>Don't Let a Dispute Derail Your Business</h2>
          <p>
            The sooner you act, the more options you have. Get a free case
            evaluation today and discover the fastest, most cost-effective path to
            resolving your dispute — without the trauma of a courtroom.
          </p>
          <div className="dr-cta-btn-group">
            <button className="dr-cta-btn-primary">Get Free Case Evaluation</button>
            <button className="dr-cta-btn-secondary">Talk to an Attorney</button>
          </div>
          <div className="dr-cta-reassurances">
            {["Free evaluation", "No obligation", "Confidential", "Fast response"].map((r, i) => (
              <div key={i} className="dr-cta-reassurance">
                <span className="dr-cta-check">✓</span>
                {r}
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default LegalDisputeResolution;
